var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgName(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.668 15a.885.885 0 0 1-.828-.574l-.708-1.884a1 1 0 0 0-.935-.649l-6.392-.004a1 1 0 0 0-.937.65l-.708 1.886a.886.886 0 1 1-1.646-.652L6.427 2.04a1.694 1.694 0 0 1 3.125-.002l4.932 11.734A.885.885 0 0 1 13.668 15M8.46 3.24a.5.5 0 0 0-.92 0L4.8 9.643a.5.5 0 0 0 .46.697l5.484-.006a.5.5 0 0 0 .459-.697z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgName);
export default __webpack_public_path__ + "static/media/name.cc31d23c229f1a991e1452079229bac3.svg";
export { ForwardRef as ReactComponent };